import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';

import { IMaskInput } from 'react-imask';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import PinDropIcon from '@mui/icons-material/PinDrop';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

import { setDataAction  } from 'redux/actions/getFormActions';
import GoogleAutoComplete from '../components/GoogleAutoComplete';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Form2 = (props) => {
    const {actions, token, formData, handleNext, handleBack } = props;
    const classes = useStyles();

    const [data, setFormData] = useState({
      payee: null,
      email: null,
      address1: null,
      address2: null,
      city: null,
      zipCode: null,
    });

    const [valid, setValid] = useState({
      payee: true,
      email: true,
    })

    let disable = true

    useEffect(() => {
      setFormData({
        payee: formData.data.payee,
        email: formData.data.receiptEmail,
        address1: formData.data.address1,
        address2: formData.data.address2,
        city: formData.data.currentCity,
        zipCode: formData.data.currentZipCode,
      });
    }, [formData])

    const handleChange = (e, label) => {
      const value = e.target.value;
      setFormData({...data, [label]:value});
      if(label === 'email') {
        setValid({...valid, email:validator.isEmail(value)});
      } 
    };

    const handleAddress = (value) => {
      const { short_name: city = '' } =  value.address_components.find(c => c.types.includes("postal_town")) || {};
      const { short_name: streetNumber = '' } =  value.address_components.find(c => c.types.includes("street_number")) || {};
      const { short_name: route = '' } =  value.address_components.find(c => c.types.includes("route")) || {};
      const { long_name: postalCode = '' } =  value.address_components.find(c => c.types.includes('postal_code')) || {};
      setFormData({
        ...data, 
        address1: (streetNumber + ' ' + route),
        city: city,
        zipCode: postalCode
      });
  }

  const handleNextButton = () => {
      actions.setDataAction({
          ...formData.data,
          payee: data.payee,
          receiptEmail: data.email,
          address1: data.address1,
          address2: data.address2,
          currentCity: data.city,
          currentZipCode: data.zipCode,
      })
      handleNext();
  }

  if(data.payee && data.email  && valid.payee  && valid.email && data.address1 && data.city && data.zipCode) {
    disable = false;
  } else {
    disable = true;
  }

  return (
    <Box sx={{px: 2}}>
          <Typography variant="h5" gutterBottom color="primary" sx={{mt: 5, mb:3}} align="center">
            Claims Check Address & Info
          </Typography>
          <Typography color="primary">Check Payee</Typography>
          <Grid container justifyContent='center' sx={{ mb: 3, mt: 2 }}>
              <Grid item xs={11}>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={2} sx={{p: 1, mt: 2}}>
                    <AccountCircle sx={{fontSize: 40 }} color="primary"/>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body2" color="primary">Who would you like the check made out to?</Typography>
                    <TextField
                      error={!valid.payee && data.payee}
                      // label="Who would you like the check made out to?"
                      variant="standard"
                      color={data.payee ? "primary" : "error"}
                      required
                      autoFocus
                      fullWidth
                      value={data.payee}
                      onChange={(e) => handleChange(e, 'payee')}
                      />
                  </Grid>
                </Grid>
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ mb: 3 }}>
                <Grid item xs={11}>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p: 1}}>
                      <EmailIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Email recipient of eCheck Claim Payments</Typography>
                      <TextField
                          error={!valid.email && data.email}
                          // label="Email recipient of eCheck Claim Payments"
                          variant="standard"
                          color={data.email ? "primary" : "error"}
                          required
                          fullWidth
                          value={data.email}
                          onChange={(e) => handleChange(e, 'email')} 
                          helperText={(!valid.email && data.email) ? "Invalid Input" : "" }
                      />
                    </Grid>
                  </Grid>
              </Grid>
          </Grid>
          <Typography color="primary">Address</Typography>
          <Grid container justifyContent='center' sx={{ mb: 3 }}>
                <Grid item xs={11}>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p: 1, mt:1}}>
                      <LocationOnIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Address Line 1</Typography>
                      {/* <TextField
                          // label="Address2"
                          variant="standard"
                          fullWidth
                          value={data.address2}
                          onChange={(e) => handleChange(e, 'address1')}
                      /> */}
                      <GoogleAutoComplete address1={data.address1} handleAddress={(value) => handleAddress(value)} />
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p: 1, mt:1}}>
                      <AddLocationAltIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="body2" color="primary">Address Line 2</Typography>
                      <TextField
                          // label="Address2"
                          variant="standard"
                          fullWidth
                          value={data.address2}
                          onChange={(e) => handleChange(e, 'address2')}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p: 1, mt:1}}>
                      <MapsHomeWorkIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography variant="body2" color="primary">City</Typography>
                        <TextField
                          // label="City"
                          variant="standard"
                          autoComplete={data.city}
                          required
                          fullWidth
                          value={data.city}
                          onChange={e => handleChange(e, 'city')}
                      />
                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={2} sx={{p: 1, mt:1}}>
                      <PinDropIcon sx={{fontSize: 40 }} color="primary"/>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography variant="body2" color="primary">ZipCode</Typography>
                      <TextField
                          // label="ZipCode"
                          variant="standard"
                          required
                          fullWidth
                          value={data.zipCode}
                          onChange={e => handleChange(e, 'zipCode')}
                      />
                    </Grid>
                  </Grid>

              </Grid>
          </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
                <Button
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  variant="contained"
                >
                Back
                </Button>

            <Button 
              onClick={handleNextButton} 
              variant="contained" 
              disabled={disable}
            >
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Box>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form2);
